export const getPaymentMethodStatuses = (paymentMethods) => {
  return paymentMethods.reduce(
    (acc, pm) => {
      if (pm.isBankAccountVerificationNeeded) {
        acc.hasPaymentMethodNeedingVerification = true;
      } else {
        acc.hasVerifiedPaymentMethod = true;
      }
      return acc;
    },
    { hasPaymentMethodNeedingVerification: false, hasVerifiedPaymentMethod: false },
  );
};

export const getVerifiedPaymentMethods = (paymentMethods) => {
  return paymentMethods?.filter((paymentMethod) => paymentMethod.paymentMethodStatus === 'verified') || [];
};
